import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  OpenInNew as OpenInNewIcon,
  ContentCopy as ContentCopyIcon,
  Check as CheckIcon,
} from '@mui/icons-material';

/**
 * DesignActionButtons - View and Share buttons for visual design split views
 *
 * @param {Object} props
 * @param {string} props.projectId - The project ID
 * @param {string} props.taskType - 'wireframes', 'designs', or 'design-system'
 */
const DesignActionButtons = ({ projectId, taskType }) => {
  const [copied, setCopied] = useState(false);

  // Use frontend origin for the view URL — opens a clean preview route in the same app
  const frontendBase = window.location.origin;
  const viewUrl = `${frontendBase}/projects/${projectId}/preview/${taskType}`;

  const buttonSx = { color: '#485869' };

  const handleView = () => {
    window.open(viewUrl, '_blank');
  };

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(viewUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.warn('Failed to copy link:', err);
    }
  };

  if (!projectId) return null;

  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
      <Tooltip title="Open in new tab">
        <IconButton size="small" onClick={handleView} sx={buttonSx}>
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title={copied ? 'Link copied!' : 'Copy shareable link'}>
        <IconButton size="small" onClick={handleShare} sx={buttonSx}>
          {copied ? (
            <CheckIcon fontSize="small" sx={{ color: '#5f8a8f' }} />
          ) : (
            <ContentCopyIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default DesignActionButtons;
